import React, { useMemo } from 'react'
import type { InboxMessage } from '../inboxTypes'
import { DateDivider } from './DateDivider'
import { MessageRow } from './MessageRow'
import {
  formatInboxTimestamp,
  getConversationAvatarUrl,
  groupMessagesByDay
} from '../utils'

interface ConversationMessageThreadProps {
  messages: InboxMessage[]
  firstGroupContent?: React.ReactNode
}

export const ConversationMessageThread: React.FC<ConversationMessageThreadProps> = ({
  messages,
  firstGroupContent
}) => {
  const dayGroups = useMemo(() => groupMessagesByDay(messages), [messages])

  return (
    <>
      {firstGroupContent}
      {dayGroups.map((group) => (
        <div key={group.dayKey}>
          <DateDivider label={group.label} />
          {group.messages.map(message => (
            <MessageRow
              key={message.id}
              authorName={message.sender.fullName}
              timestamp={formatInboxTimestamp(message.createdAt)}
              isCurrentUser={message.sender.isCurrentUser}
              body={message.body}
              avatarUrl={getConversationAvatarUrl([message.sender])}
              senderVariant={message.system === 'canary' ? 'canary' : 'user'}
            />
          ))}
        </div>
      ))}
    </>
  )
}
